module.exports = __webpack_public_path__ + "static/empty-states-skeletons-do-d2ec8330463cf3fa10654da33aac5032.png";